import { Vec2 } from "../../models/SyntheticMap";

interface JoystickProps {
  position: Vec2;
  max: Vec2
}

export default function Joystick({
  position,
  max,
}: JoystickProps) {

  const maxMovement = 35;
  const normalizedX = (position.x || 0) / (max.x || 1);
  const normalizedY = (position.y || 0) / (max.y || 1);
  return (
    <div
      style={{
        width: "90px",
        height: "90px",
        borderRadius: "50%",
        backgroundColor: "#1e1e1e",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        marginLeft: "10px",
        marginRight: "10px",
        boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
        zIndex: 2000,
      }}
    >
      <div
        style={{
          width: "25px",
          height: "25px",
          borderRadius: "50%",
          backgroundColor: "#444",
          position: "absolute",
          top: `calc(50% - 12.5px + ${-normalizedY * maxMovement}px)`,
          left: `calc(50% - 12.5px + ${normalizedX * maxMovement}px)`,
          boxShadow: "inset 0 0 5px rgba(0, 0, 0, 0.5)",
          transition: "top 0.1s, left 0.1s",
        }}
      />
    </div>
  );
}